module.exports = __webpack_public_path__ + "static/media/graph_temp_02.8103af96.jpg";